const mainATC = document.querySelector('.main_btn_qty_col');
const stickyBar = document.querySelector('.sticky_product_qty');
function toggleStickyATC() {
  if (!mainATC && !stickyBar) return;
  const rect = mainATC.getBoundingClientRect();
  const isOutOfView = rect.bottom < 300 || rect.top > window.innerHeight;

  if (isOutOfView) {
    stickyBar.classList.add('active');
  } else {
    stickyBar.classList.remove('active');
  }
}

window.addEventListener('scroll', toggleStickyATC);
window.addEventListener('resize', toggleStickyATC);

if(stickyBar){
  const innerVariantPicker = stickyBar.querySelector('.variant-wrapper');
  const innerInputWrapper = stickyBar.querySelector('.js-qty__wrapper');
  const innerATCBtn = stickyBar.querySelector('.add-to-cart');
  if(innerVariantPicker){
    const innerSelectTag = innerVariantPicker.querySelector('select');
    if(innerSelectTag){
      innerSelectTag.addEventListener('change', updateActualVariant.bind(this));
    }
  }
  if(innerInputWrapper){
    const js_plus_btn = innerInputWrapper.querySelector('.js-qty__adjust--plus');
    const js_minus_btn = innerInputWrapper.querySelector('.js-qty__adjust--minus');
    const innerInputPicker = stickyBar.querySelector('.js-qty__num');
    if(js_minus_btn || js_plus_btn){
      js_plus_btn.addEventListener('click', updateActualInput.bind(this));      
      js_minus_btn.addEventListener('click', updateActualInput.bind(this));      
    }
  }
  if(innerATCBtn){
    innerATCBtn.addEventListener('click', clickMainATCButton.bind(this));
  }
}

function updateActualVariant(evt){
  const currentTarget = evt.target;
  if(currentTarget){
    const currentValue = currentTarget.value;
    const closestMainWrapper = currentTarget.closest('.product-single__meta');
    if(closestMainWrapper){
      const main_variant_picker = closestMainWrapper.querySelector('.variant_picker_product');
      if(main_variant_picker){
        const variant_picker_select_tag = main_variant_picker.querySelector('select');
        if(variant_picker_select_tag){
          variant_picker_select_tag.value = currentValue;
          variant_picker_select_tag.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }
}
function clickMainATCButton(evt){
  const currentTarget = evt.target;
  if(currentTarget){
    const currentValue = currentTarget.value;
    const closestMainWrapper = currentTarget.closest('.product-single__meta');
    if(closestMainWrapper){
      const mainATCWrapper = closestMainWrapper.querySelector('.product-main-btn');
      if(mainATCWrapper){
        const mainATCBtn = mainATCWrapper.querySelector('.add-to-cart');
        if(mainATCBtn){
          mainATCBtn.click();
        }
      }
    }
  }
}
function updateActualInput(evt) {
  const currentTarget = evt.target;
  if (currentTarget) {
    const currentValue = currentTarget.value;
    const closestMainWrapper = currentTarget.closest('.product-single__meta');
    if (closestMainWrapper) {
      const main_input_picker = closestMainWrapper.querySelector('.js-qty__wrapper');
      if (main_input_picker) {
        const js_plus_btn = main_input_picker.querySelector('.js-qty__adjust--plus');
        const js_minus_btn = main_input_picker.querySelector('.js-qty__adjust--minus');
        if(js_plus_btn || js_minus_btn){
          if(currentTarget.classList.contains('js-qty__adjust--plus')) js_plus_btn.click();
          if(currentTarget.classList.contains('js-qty__adjust--minus')) js_minus_btn.click();
        }
      }
    }
  }
}











